import ApiService from '@/services/ApiService';

const apiService = new ApiService();

const get = function (unitId) {
    return apiService.get('unit', `${unitId}`);
}

const getByUserId = function (userId) {
    return apiService.get('unit', `?userId=${userId}`);
}

const getByGroup = function (group) {
return apiService.get('unit', `group/?group=${group}`);
}

const getByConfigPull = function () {
    return apiService.get('unit', `configpull`);
    }

const create = function (data) {
    return apiService.post('unit', data);
}

const update = function (data) {
    return apiService.put('unit', data);
}

const deleteUnit = function (unitId) {
    return apiService.delete('unit', `${unitId}`);
}

export default {
    get,
    getByUserId,
    getByConfigPull,
    getByGroup,
    create,
    update,
    deleteUnit
}